import React, { useState } from "react";
import { Currency } from "../../components/WishingWell/wishingWellData";
import WishingWell from "../../components/WishingWell";
import styles from "./Registry.module.css";

const Registry: React.FC = () => {
  const [currency, setCurrency] = useState<Currency>("USD");

  return (
    <>
      <section className="container">
        <div className="pageTitle">Registry</div>
        <div className="blurb">
          We are so grateful for your love and support, which means
          more to us than any gift. Since we've already built a cozy
          home together, what we'd love most is your help in creating
          new memories!
        </div>
      </section>

      <section className="container">
        <div className={styles.registryGrid}>
          <div className={styles.wishingWellColumn}>
          <div className="pageTitle">Wishing Well</div>
          <div className="blurb">
            Our wishing well will go toward our honeymoon adventure — whether
            it's morning coffees on quiet streets, sunset dinners by the ocean,
            or exciting excursions we'll remember forever. Every contribution,
            big or small, helps us fill our trip with moments we'll cherish.
          </div>
            <WishingWell 
              currency={currency} 
              onCurrencyChange={setCurrency} 
            />
          </div>

          {/* Right Column - Amazon Registry */}
          <div className={styles.registryColumn}>
            <div className="pageTitle">Gift Registry</div>
            <div className="blurb">
              <p>For those who prefer giving a more traditional gift, we’ve put together a small Amazon registry with a few items we’ll enjoy as we begin this next chapter together. Truly, we already have what we need in life—family, friends, and each other—so we’ve kept the list intentionally small and practical: thoughtful home essentials, cozy touches, and a couple of simple upgrades. Because many of our guests will be traveling from overseas or interstate, the easiest option is to have gifts shipped directly to our home to avoid extra luggage and hassle. Your presence and well-wishes mean the world, and any kindness is deeply appreciated.</p>
              <p>Outside of the Amazon list, if you’re looking for something a bit more personal, we both enjoy cocktails—so a bottle of fine liquor is always appreciated.</p>
            </div>
            <a 
              href="https://www.amazon.com/wedding/share/alexandriaandmorgan"      
              className={'accent-btn'}
            >
              View our Amazon Registry
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Registry;
